enum FlowPlaceholderType {
    MOBILE = "mobile",
    DESKTOP = "desktop"
}

export default FlowPlaceholderType;
